export default [
  {
    name: 'PPEs Requests',
    icon: 'ti-thumb-up',
    path: '/admin/ppes-requests'
  },
  {
    name: 'Log Out',
    icon: 'ti-power-off',
    path: '/login?logout=true'
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js